import { pressOsShiftTab } from '@/tauri/dictation/api';

export const handlePreviousField = (): void => {
  void pressOsShiftTab();
};
